// Packages
import { useState } from 'react';

// Components
import AdminLayout from 'layouts/Admin';
import BTDPagination from 'components/BTDUI/BTDPagination';
import ExpiredBookingsList from 'modules/Bookings/components/ExpiredList';

// Other
import useApi from 'hooks/useApi';

const ExpiredBookingListScreen = () => {

    const [page, setPage] = useState(1);

    const { data: bookings, isLoading, meta, onChange } = useApi('/orders/expired?page=' + page);


    return(
        <AdminLayout>

            <h2 style={{marginTop: '35px'}}>Expired Bookings</h2>

            {meta && meta.length !== 0 && bookings.length !== 0 &&
                <p style={{marginBottom: '40px'}}>Showing expired bookings {meta.from} to {meta.to} of {meta.total}</p>
            }
            
            <ExpiredBookingsList 
                isLoading={isLoading}  
                items={bookings} 
            />

            {meta && meta.length !== 0 && bookings.length !== 0 &&
                <BTDPagination
                currentPage={meta.current_page}
                onChange={(value) => {
                    setPage(value)
                    onChange()}
                }
                totalPages={Math.ceil(meta.total / meta.per_page)}
                style={{margin: '20px auto 60px auto', width: 'max-content'}}
                />
            }

        </AdminLayout>
    )

}

export default ExpiredBookingListScreen;